/**
 * @generated SignedSource<<4de5d554fd4f0dabe8b47fed44a8a09f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageGroupDialog_clients$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly displayName: string | null | undefined;
      readonly email: string | null | undefined;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ClientAddableItem_client">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "ManageGroupDialog_clients";
};
export type ManageGroupDialog_clients$key = {
  readonly " $data"?: ManageGroupDialog_clients$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageGroupDialog_clients">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageGroupDialog_clients",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClientAddableItem_client"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientConnection",
  "abstractKey": null
};

(node as any).hash = "cdf329f7812913e9e20f397fa8aeef2f";

export default node;
